<template>
  <FullScreenLoading v-if="fullScreenloading"/>

  <form-wizard v-else class="mt-3" ref="onboardingWizard" color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="go back" subtitle="" nextButtonText="continue" finishButtonText="start my journey" stepSize="xs">

    <div slot="title">
      <img src="/improvee_logo.svg" class="flex-1 fill-current text-primary" height="38" />
    </div>

    <span slot="custom-buttons-right" slot-scope="props">
      <span class="m-1 mb-2 text-center" v-if="props.activeTabIndex === 0 && !userRegistered">
        <!-- <vx-tooltip text="go to the login page"> -->
          <span class="hover:underline cursor-pointer mr-2 text-sm" @click="goToLogin"> I am registered</span>
        <!-- </vx-tooltip> -->
      </span>
    </span>

<!-- ACHIEVE ANYTHING ========================================================================== -->
    <tab-content title="" :before-change="trackStep('achieve-anything-step-finished')">

      <div class="md:flex">
        <div class="w-4/5 md:w-3/5 mx-auto flex content-center">
          <img class="" src="@/assets/images/onboarding/meditation.svg"/>
        </div>


        <div class="flex flex-wrap content-center text-center md:w-1/2 md:text-left">
          <IntroStepContent/>
        </div>
      </div>

    </tab-content>


    <tab-content title="" :before-change="checkIAmPicked">
      <div class="md:flex md:content-center">
        <div class="w-4/5 md:w-3/5 mx-auto flex content-center">
          <img class="" src="@/assets/images/onboarding/introduce.svg" />
        </div>

        <div class="flex flex-wrap content-center justify-center md:justify-start text-center md:text-left text-dark">
          <div class="w-full">
            <span class="text-black mb-2 md:text-5xl text-4xl"><span class="font-bold text-dark">I am...</span></span>


            <div class="mt-2">
                 <p class="onboarding-paragraph text-dark">
                  Introduce yourself, that's the only way improvee.io can be tailored to your individual needs.
                </p>
            </div>

            <div class="mt-8">
              <div class="flex items-center">
                <feather-icon  class="font-semibold" icon="UserIcon" stroke-width="3" svgClasses="h-5 w-5"/>
                <span class="ml-2 text-dark text-2xl font-black">my age</span>
              </div>
              <div class="flex items-center flex-wrap">
                  <Checkbox class="mr-6 text-xl" key="age<18" initValue="age<18" title="< 18" icon="" v-model="iAm" />
                  <Checkbox class="mr-6 text-xl" key="age18-24" initValue="age18-24" title="18-24" icon="" v-model="iAm" />
                  <Checkbox class="mr-6 text-xl" key="age25-34" initValue="age25-34" title="25-34" icon="" v-model="iAm" />

                  <Checkbox class="mr-6 text-xl" key="age35-44" initValue="age35-44" title="35-44" icon="" v-model="iAm" />

                 <Checkbox class="mr-6 text-xl" key="age-45-54" initValue="age-45-54" title="45-54" icon="" v-model="iAm" />

                 <Checkbox class="mr-6 text-xl" key="age-55+" initValue="age-55+" title=" 55+" icon="" v-model="iAm" />
              </div>

            </div>

            <div class="mt-8">
              <div class="flex items-center">
                <feather-icon  class="font-semibold" icon="BriefcaseIcon" stroke-width="3" svgClasses="h-5 w-5"/>
                <span class="ml-2 text-dark text-2xl font-black">status</span>
              </div>

              <div class="flex items-center flex-wrap">
                <Checkbox class="mr-6 text-xl" key="student" initValue="student" title="student" icon="" v-model="iAmOccup" />
                <Checkbox class="mr-6 text-xl" key="employee" initValue="employee" title="employee" icon="" v-model="iAmOccup" />

                <Checkbox class="mr-6 text-xl" key="employer" initValue="employer" title="employer" icon="" v-model="iAmOccup" />

                <Checkbox class="mr-6 text-xl" key="self-employed" initValue="self-employed" title="self-employed" icon="" v-model="iAmOccup" />


                <Checkbox class="mr-6 text-xl" key="other" initValue="other" title="other" icon="" v-model="iAmOccup" />
              </div>
            </div>
          </div>

           <span class="text-danger" v-visible="iAmError && (!iAmOccup || !iAm)">Choose at least one.</span>
        </div>
      </div>
      </tab-content>





    <tab-content title="" :before-change="checkPositiveNegativePicked">
      <div class="md:flex md:content-center">
        <div class="w-4/5 md:w-3/5 mx-auto flex content-center">
          <img class="md:px-24" src="@/assets/images/onboarding/lately.svg" />
        </div>


        <div class="flex flex-wrap content-center justify-center md:justify-start text-center md:text-left text-dark">
          <div class="w-full">

         <span class="text-black mb-2 md:text-5xl text-4xl"><span class="font-bold text-dark">Lately, I've been...</span></span>


    <p class="onboarding-paragraph text-dark">
      Reflect on your last month because that's what matters - that's who you are right now.
    </p>

            <div class="mt-8">
              <div class="flex items-center">
                <feather-icon  class="font-semibold" icon="ThumbsUpIcon" stroke-width="3" svgClasses="h-5 w-5"/>
                <span class="ml-2 text-dark text-2xl font-black">positive</span>
              </div>

              <div class="flex items-center flex-wrap">
                  <Checkbox class="mr-6 text-xl" key="productive" initValue="productive" title="productive" icon="" v-model="positive" />
                  <Checkbox class="mr-6 text-xl" key="energized" initValue="energized" title="energized" icon="" v-model="positive" />

                  <Checkbox class="mr-6 text-xl" key="calm" initValue="calm" title="calm" icon="" v-model="positive" />

                  <Checkbox class="mr-6 text-xl" key="motivated" initValue="motivated" title="motivated" icon="" v-model="positive" />

                 <Checkbox class="mr-6 text-xl" key="healthy" initValue="healthy" title="healthy" icon="" v-model="positive" />

                 <Checkbox class="mr-6 text-xl" key="sleeping well" initValue="sleeping well" title="sleeping well" icon="" v-model="positive" />
              </div>

            </div>

            <div class="mt-8">
              <div class="flex items-center">
                <feather-icon  class="font-semibold" icon="ThumbsDownIcon" stroke-width="3" svgClasses="h-5 w-5"/>
                <span class="ml-2 text-dark text-2xl font-black">negative</span>
              </div>

              <div class="flex items-center flex-wrap">
                <Checkbox class="mr-6 text-xl" key="procrastinating" initValue="procrastinating" title="procrastinating" icon="" v-model="negative" />
                <Checkbox class="mr-6 text-xl" key="tired" initValue="tired" title="tired" icon="" v-model="negative" />

                <Checkbox class="mr-6 text-xl" key="stressed" initValue="stressed" title="stressed" icon="" v-model="negative" />

                <Checkbox class="mr-6 text-xl" key="unhealthy" initValue="unhealthy" title="unhealthy" icon="" v-model="negative" />

                <Checkbox class="mr-6 text-xl" key="lazy" initValue="lazy" title="lazy" icon="" v-model="negative" />

                <Checkbox class="mr-6 text-xl" key="sleeping poorly" initValue="sleeping poorly" title="sleeping poorly" icon="" v-model="negative" />
              </div>
            </div>
          </div>

           <span class="text-danger" v-visible="positiveNegativeError && (positive.length === 0 && negative.length === 0)">Choose at least one.</span>
        </div>
      </div>
      </tab-content>

    <!-- I wish to ========================================================== -->
    <tab-content title="" :before-change="checkIWishToPicked">
      <div class="md:flex md:content-center">
        <div class="w-4/5 md:w-3/5 mx-auto flex content-center">
          <img class="" src="@/assets/images/onboarding/plan.svg" />
        </div>

        <div class="flex flex-wrap content-center justify-center md:justify-start text-center md:text-left text-dark">
          <div>
            <span class="text-black mb-2 md:text-5xl text-4xl"><span class="font-bold text-dark">I wish to...</span></span>

        <!--     <div class="mt-2">
              <p class="font-italic w-full">"Let the destination drive your actions, not the other way around."</p>
            </div> -->
            <p class="onboarding-paragraph text-dark">
             What changes do you want to achieve in your life?
            </p>


            <div v-if="$store.getters.isMobile" class="text-lg">
              <div class="flex mt-4 justify-evenly items-center">
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[0].initValue" :initValue="iWishToDescriptions[0].initValue" :title="iWishToDescriptions[0].title" :icon="iWishToDescriptions[0].icon" v-model="iWishTo" />
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[1].initValue" :initValue="iWishToDescriptions[1].initValue" :title="iWishToDescriptions[1].title" :icon="iWishToDescriptions[1].icon" v-model="iWishTo" />
              </div>
              <div class="flex mt-4 justify-evenly items-center">
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[2].initValue" :initValue="iWishToDescriptions[2].initValue" :title="iWishToDescriptions[2].title" :icon="iWishToDescriptions[2].icon" v-model="iWishTo" />
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[3].initValue" :initValue="iWishToDescriptions[3].initValue" :title="iWishToDescriptions[3].title" :icon="iWishToDescriptions[3].icon" v-model="iWishTo" />
              </div>
              <div class="flex mt-4 justify-evenly items-center">
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[4].initValue" :initValue="iWishToDescriptions[4].initValue" :title="iWishToDescriptions[4].title" :icon="iWishToDescriptions[4].icon" v-model="iWishTo" />
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[5].initValue" :initValue="iWishToDescriptions[5].initValue" :title="iWishToDescriptions[5].title" :icon="iWishToDescriptions[5].icon" v-model="iWishTo" />
              </div>
              <div class="flex mt-4 justify-evenly items-center">
                  <Checkbox class="w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[6].initValue" :initValue="iWishToDescriptions[6].initValue" :title="iWishToDescriptions[6].title" :icon="iWishToDescriptions[6].icon" v-model="iWishTo" />
                  <Checkbox class="w-1/2 m-2 lg:w-1/4 p-4" :key="iWishToDescriptions[7].initValue" :initValue="iWishToDescriptions[7].initValue" :title="iWishToDescriptions[7].title" :icon="iWishToDescriptions[7].icon" v-model="iWishTo" />
               </div>
            </div>
            <div v-else>
            <div class="flex mt-4 items-center">
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[0].initValue" :initValue="iWishToDescriptions[0].initValue" :title="iWishToDescriptions[0].title" :icon="iWishToDescriptions[0].icon" v-model="iWishTo" />
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[1].initValue" :initValue="iWishToDescriptions[1].initValue" :title="iWishToDescriptions[1].title" :icon="iWishToDescriptions[1].icon" v-model="iWishTo" />

                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[2].initValue" :initValue="iWishToDescriptions[2].initValue" :title="iWishToDescriptions[2].title" :icon="iWishToDescriptions[2].icon" v-model="iWishTo" />
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[3].initValue" :initValue="iWishToDescriptions[3].initValue" :title="iWishToDescriptions[3].title" :icon="iWishToDescriptions[3].icon" v-model="iWishTo" />
            </div>
             <div class="flex justify-evenly items-center">
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[4].initValue" :initValue="iWishToDescriptions[4].initValue" :title="iWishToDescriptions[4].title " :icon="iWishToDescriptions[4].icon" v-model="iWishTo" />
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[5].initValue" :initValue="iWishToDescriptions[5].initValue" :title="iWishToDescriptions[5].title" :icon="iWishToDescriptions[5].icon" v-model="iWishTo" />
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4" :key="iWishToDescriptions[6].initValue" :initValue="iWishToDescriptions[6].initValue" :title="iWishToDescriptions[6].title" :icon="iWishToDescriptions[6].icon" v-model="iWishTo" />
                <Checkbox class="text-xl w-1/2 m-2 lg:w-1/4 p-4" :key="iWishToDescriptions[7].initValue" :initValue="iWishToDescriptions[7].initValue" :title="iWishToDescriptions[7].title" :icon="iWishToDescriptions[7].icon" v-model="iWishTo" />
             </div>
            </div>
          </div>
           <span class="text-danger" v-visible="iWishToError && iWishTo.length === 0">Choose at least one.</span>
          <!-- {{iWishToDescriptions}} -->
        </div>
        
      </div>
      </tab-content>







    <!--an AI-based solution. =========================================================  -->
    <tab-content title="" :before-change="youCanYouWillFinished">
      <div class="md:flex md:content-center">

        <div class="w-4/5 md:w-3/5 mx-auto flex content-center">
          <img class="" src="@/assets/images/onboarding/teaching.svg" />
        </div>

        <div class="flex flex-wrap content-center text-center justify-center md:w-2/3 md:text-left md:justify-start">
          <div class="w-full">

            <span class="text-black mb-2 md:text-5xl text-4xl">
              We have <span class="font-bold">an AI-based solution</span> 
            </span>

            <p class="onboarding-paragraph text-dark w-full">
              Improvee.io is a life companion that helps you do the right things the right way
            </p>

            <div>

              <div class="mt-8">
                <span class="text-dark text-2xl font-black  flex items-center">
                <feather-icon class="font-semibold mr-1" icon="MapIcon" stroke-width="5" svgClasses="h-5 w-5"/>
              Action board</span>
              </div>

              <div class="flex flex-wrap">
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="5" svgClasses="h-5 w-5"/>goal setting</span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>habit builder</span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>todo list</span>
               <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>recommended actions</span>
            </div>


              <div class="mt-8">
                <span class="text-dark text-2xl font-black  flex items-center">
                <feather-icon class="font-semibold mr-1" icon="MapPinIcon" stroke-width="5" svgClasses="h-5 w-5"/>
              My journey</span>
              </div>

              <div class="flex flex-wrap">
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="5" svgClasses="h-5 w-5"/>vision board</span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>mood tracker</span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>guided journal</span>
               <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>reflection</span>
            </div>


            <div class="mt-8">
                <span class="text-dark text-2xl font-black  flex items-center">
                <feather-icon class="font-semibold mr-1" icon="BookOpenIcon" stroke-width="5" svgClasses="h-5 w-5"/>
              Knowledge page</span>
              </div>

              <div class="flex flex-wrap">
                <span class="inline-flex flex items-center mr-6 text-lg text-dark  font-semibold"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/><span class="aicolor">AI improvee.io coach</span></span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="5" svgClasses="h-5 w-5"/>academy</span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>personalized plan</span>
                <span class="inline-flex flex items-center mr-6 text-lg text-dark"><feather-icon class="font-semibold mr-1" icon="CheckIcon" stroke-width="3" svgClasses="h-5 w-5"/>quick tips</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    </tab-content>
  </form-wizard>
</template>

<script>
/* eslint-disable */

import _ from 'lodash'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import IntroStepContent from './Wizard/IntroStepContent'
import HowToCreateDream from './Wizard/HowToCreateDream'
import DreamText from './Wizard/DreamText'
import Feature from './Wizard/Feature'
import AllFeatures from './Wizard/AllFeatures'
import DreamTextOutro from './Wizard/DreamTextOutro'
import JournalText from './Wizard/JournalText'
import GoalText from './Wizard/GoalText'
import GoalTextOutro from './Wizard/GoalTextOutro'
import Checkbox from './Wizard/Checkbox'
import * as DateHelper from '@/helpers/date'
import FullScreenLoading   from '@/views/Self-Improvee/Generic/FullScreenLoading'
import trackAnalytics from '@/helpers/trackAnalytics'
import CategorySelect from './../Dreams/CategorySelect'
import DemoDreams from '@/models/DemoDreams'
import firebase from 'firebase/app'
import 'firebase/auth'
// import { LearnAppGoals }  from './../Goals/GoalsExamples'

// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    what_are_you_solving: {
      required: 'Please tell us what you expect from us so that we can improve for you and others.',
    },
    dream_title: {
      required: 'This is a crucial part of your journey',
    },
    dream_why: {
      required: 'If you don\'t know why, then you shouldn\'t pursue it',
    },
    biggest_acomplishment: {
      required: 'You have certainly achieved something already',
    },
    goal_title: {
      required: 'Dreams don\'t work unless you do',
    },
    task_title: {
      required: 'You are what you do, not what you say you\'ll do',
    },
    routine_title: {
      required: 'Even using improvee.io everyday is a routine',
    },
    next_month_step: {
      required: 'Job title name is required',
      alpha: 'Job title may only contain alphabetic characters'
    },
    proposal_title: {
      required: 'Proposal title name is required',
      alpha: 'Proposal title may only contain alphabetic characters'
    },
    event_name: {
      required: 'Event name is required',
      alpha: 'Event name may only contain alphabetic characters'
    },
  }
}

// register custom messages
Validator.localize('en', dict)

export default {
  components: {
    FormWizard,
    TabContent,
    IntroStepContent,
    DreamText,
    HowToCreateDream,
    JournalText,
    GoalText,
    GoalTextOutro,
    DreamTextOutro,
    FullScreenLoading,
    CategorySelect,
    Checkbox,
    Feature,
    AllFeatures
  },
  props: ['userRegistered'],
  data () {
    return {
      iWishTo: [],
      dream: { category: 'other' },
      imageFile: null,
      goal: {},
      task: {},
      routine: {},
      fullScreenloading: false,
      tracks: [],
      doIKnowMyDream: 'yes',
      featuresCount: 3,
      iAm: null,
      positive: [],
      negative: [],
      positiveNegativeError: null,
      iAmOccup: null,
      iWishToError: null,
      iAmError: null,
      iWishToDescriptions: [
      { initValue: "knowMore",  title: "Know more about myself", icon: "BookOpenIcon" },
      { initValue: "manageTimeAndTasks",  title: "Manage time and tasks", icon: "CheckCircleIcon" },
      { initValue: "motivation",  title: "Be motivated and productive", icon: "BatteryChargingIcon" },
      { initValue: "dreamsAndGoals",  title: "Pursue dreams and goals", icon: "TrendingUpIcon" },
      { initValue: "balance",  title: "Improve work-life balance", icon: "BriefcaseIcon" },
      { initValue: "habits",  title: "Build lasting habits", icon: "ActivityIcon"  },
      { initValue: "anxiety",  title: "Reduce stress and anxiety", icon: "SmileIcon" },
      { initValue: "procrastination",  title: "Reduce procrastination", icon: "YoutubeIcon" }
    ],
      features: {
        'vision board': { name: 'vision board', icon: 'CompassIcon', description: 'Break free from autopilot and follow your passions that propel you forward.' },
        'goal tracking': { name: 'goal tracking', icon: 'TargetIcon', description: 'Set meaningful long-term and short-term goals to increase your productivity and fulfillment.' },
        'to-do list': { name: 'to-do list', icon: 'CheckCircleIcon', description: 'Easily prioritize, streamline your days, and gain more focus and time for the things that matter.' },
        'habit builder': { name: 'habit builder', icon: 'RefreshCcwIcon', description: 'Build powerful habits to develop your life. Good habits are the answer to almost everything in life.' },
        'recommended actions': { name: 'recommended actions', icon: 'MapIcon', description: "Evolve your growth mindset through tailored goal/routine/task templates. Don't go through life; grow through life." },
        'self-discipline': { name: 'self-discipline', icon: 'BarChartIcon', description: 'Create structure in your life and develop unbreakable resilience. Your routine creates your results.' },
        'journal': { name: 'journal', icon: 'FeatherIcon', description: 'Keep track of your thoughts and ideas and get to know yourself better, thanks to a guided journal.' },
        'daily check-ins': { name: 'daily check-ins', icon: 'CalendarIcon', description: 'Track your mood, well-being, and progress. Explore yourself and your patterns easily at a glance.'},
        'reflection': { name: 'reflection', icon: 'BookOpenIcon', description: 'Become accountable for your passions and understand your time and feelings through quick weekly/monthly reflection.' },
        'work-life balance': { name: 'work-life balance', icon: 'SunriseIcon', description: 'Develop a life where each aspect of your growth is in harmony with the other.' },
        'insights': { name: 'insights', icon: 'PieChartIcon', description: 'Visualize your progress and get a quick overview of your continuous gradual improvement.' }
      },
      checkboxFeatureMapping: {
        "knowMore": ['to-do list', 'journal', 'reflection', 'insights'],
        "manageTimeAndTasks": ['goal tracking', 'to-do list', 'habit builder', ],
        "motivation": ['vision board', 'goal tracking', 'self-discipline', ],
        "dreamsAndGoals": ['goal tracking', 'to-do list', 'recommended actions'],
        "balance": ['goal tracking', 'recommended actions', 'work-life balance'],
        "habits": ['goal tracking', 'habit builder', 'daily check-ins'],
        "anxiety": ['recommended actions', 'journal', 'work-life balance'],
        "procrastination": ['goal tracking'],
      },
      featuresToShow: ['vision board', 'goal tracking', 'daily check-ins']
    }
  },
  computed: {
    moreFeatures () {
      return _.map(
        _.difference(_.keys(this.features), this.featuresToShow),
        (feature) => this.features[feature]
      )
    }
  },
  watch: {
    'iWishTo': {
      immediate: false,
      handler (iWishTo) {
        let toShow = this.chooseFeatures(iWishTo)

        if (toShow.length < this.featuresCount) {
          const unused = _.difference(_.keys(this.features), toShow)
          toShow = _.take([...this.featuresToShow, ...unused], this.featuresCount)
        }

        this.featuresToShow = toShow
      }
    },
  },
  methods: {
    checkPositiveNegativePicked () {
      console.log("this.positive.length", this.positive.length)
      console.log("this.negative.length", this.negative.length)
      return new Promise((resolve, reject) => {
        if (this.positive.length > 0 || this.negative.length > 0) {
          this.positiveNegativeError = null
          resolve(true)
        } else {
          this.positiveNegativeError = true
          reject()
        }
      })
    },
    checkIWishToPicked () {
      return new Promise((resolve, reject) => {
        if (this.iWishTo.length > 0) {
          this.iWishToError = null
          resolve(true)
        } else {
          this.iWishToError = "Choose at least one."
          reject()
        }
      })
    },
    checkIAmPicked () {
      return new Promise((resolve, reject) => {
        if (this.iAm && this.iAmOccup) {
          this.iAmError = null
          resolve(true)
        } else {
          this.iAmError = true
          reject()
        }
      })
    },
    goToLogin () {
      this.$router.push('/login').catch(() => {})
    },
    chooseFeatures (checkboxes) {
      const chosenFeatures =  _.take(
        _.shuffle(
          _.uniq(
            _.flatten(
              _.map(checkboxes, (check) => this.checkboxFeatureMapping[check] ))))
        , 3)

      return chosenFeatures
    },
    trackStep (step) {
      return () => {
        return new Promise((resolve) => {
          this.track(step)
          resolve(true)
        })
      }
    },
    track (step) {
      trackAnalytics(this, 'app_action', `onboarding-journey-${step}`, null, 0)
    },
    validateDreamStep () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-dream').then(result => {
          if (result) {
            trackAnalytics(this, 'app_action', 'onboarding-journey-step-dream-finished', null, 0)
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    youCanYouWillFinished () {
     return new Promise((resolve) => {
        this.save()
        resolve(true)
      })
    },
    async save () {
      this.fullScreenloading = true

      console.log(this.$router.currentRoute.query)

      const whatAreYouTryingToSolve = this.iWishTo
      const onboardingPath = this.$router.currentRoute.name

      if (!this.userRegistered) {
        this.$router.push({ name: 'anon', query: { ...this.$router.currentRoute.query, onboardingFinished: true, whatAreYouTryingToSolve, onboardingPath, positive: this.positive, negative: this.negative, iAmAge: this.iAm, iAmOccup: this.iAmOccup } })
      } else {
        await this.$store.dispatch('UPDATE_USER_ONBOARDED', false)
        this.$store.dispatch('ADD_INITIAL_LESSONS_DELAYED')
        this.$store.dispatch('ADD_INITIAL_NOTIFICATIONS')

        const user = Object.assign({}, this.$store.getters.user)
        user.userInfo = Object.assign({}, user.userInfo)

        user.whatAreYouTryingToSolve = whatAreYouTryingToSolve
        user.userInfo.positive = this.positive
        user.userInfo.negative = this.negative
        user.userInfo.iAmAge = this.iAm
        user.userInfo.iAmOccup = this.iAmOccup


        this.$store.dispatch('UPDATE_USER', { user })
      }

      this.fullScreenloading = false
    },
  },
  mounted () {
    this.tracks = DemoDreams.tracks
    this.track('before')

    this.iWishToDescriptions = _.shuffle(this.iWishToDescriptions)

  }
}
</script>
<style>
.img-upload, .con-upload, .con-img-upload, .con-input-upload {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

.wizard-btn {
  border-radius: 1rem !important;
  font-size: larger !important;
}

.view-upload {
  display: none !important;
}

.onboarding-image {
  max-height: 500px;
}

.onboarding-image-smaller {
  max-height: 400px;
}

.onboarding-paragraph {
  margin-top: 1rem;
  font-size: 1.3rem;
}

.onboarding-input {
  margin-top: 2rem;
}

.onboarding-bold {
  font-weight: bold;
}

.onboarding-it {
  font-style: italic;
}

@media screen and (min-width: 1200px) {
  .onboarding__text-right {

  }
}

@media screen and (min-width: 1200px) {
  .wizard-tab-content {
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .wizard-card-footer{
    margin-left: 10rem;
    margin-right: 10rem;
  }
}
</style>
